// extracted by mini-css-extract-plugin
export default {"hexRoot":"Tag_hexRoot__cxPne"};